import { faCopy } from '@fortawesome/free-regular-svg-icons'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CopyTextWrapper from '../../../../../components/CopyTextWrapper'

interface BankInfoProps {
  title: string
  value?: string | null
  copy?: boolean
  warning?: boolean
}
const BankInfoCell: React.FC<BankInfoProps> = ({
  title,
  value,
  copy,
  warning,
}) => {
  return (
    <div className="mr-5">
      <p className="text-description">{title}</p>
      <div className="flex gap-2 items-center">
        <p
          className={`text-default ${warning ? 'text-amber-600 font-semibold' : ''}`}
        >
          {value}
        </p>
        {warning && (
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="w-4 h-4 text-amber-500"
          />
        )}
        {copy && (
          <CopyTextWrapper text={value ? value : ''}>
            <span className="text-brand-accent dark:text-white cursor-pointer">
              <FontAwesomeIcon icon={faCopy} />
            </span>
          </CopyTextWrapper>
        )}
      </div>
    </div>
  )
}

export default BankInfoCell
